import { io } from 'socket.io-client';

let socketBaseUrl = process.env.SOCKET_URL || '';
let socket = null;
/** Tracks the auth token used for the active connection (must reconnect when it changes). */
let connectToken = '';
/** Tracks the base URL used for the active connection (must reconnect when public config arrives). */
let connectUrl = '';

/** Called after /api/public-config (merged with client SOCKET_URL when server omits SOCKET_PUBLIC_URL). */
export const setSocketBaseUrl = (url) => {
  const next = url == null ? '' : String(url);
  if (socketBaseUrl === next) return;
  socketBaseUrl = next;
  if (socket) {
    socket.disconnect();
    socket = null;
    connectToken = '';
    connectUrl = '';
  }
};

export const getSocket = (token) => {
  if (!token) return null;
  if (socket && (connectToken !== token || connectUrl !== socketBaseUrl)) {
    socket.disconnect();
    socket = null;
    connectToken = '';
    connectUrl = '';
  }
  if (!socket) {
    const opts = { auth: { token }, transports: ['websocket', 'polling'] };
    socket = socketBaseUrl ? io(socketBaseUrl, opts) : io(opts);
    connectUrl = socketBaseUrl;
    connectToken = token;
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    connectToken = '';
    connectUrl = '';
  }
};
